import type { BadgeProps } from 'node_modules/@wartek-id/badge/dist'
import type {
  PeriodikPegawaiState,
  PeriodikPerformancePracticeResult,
  PeriodikPerformancePredicateResult,
  PeriodikRealization,
  PeriodikState,
} from 'types/kinerja'

export const PERIODIK_STATE_LABELS: Record<PeriodikState, string> = {
  COMPLETED: 'Selesai',
  IN_PROGRESS: 'Belum selesai',
  NOT_STARTED: 'Belum dapat diakses',
}

export const PERIODIK_PEGAWAI_STATE_LABELS: Record<
  PeriodikPegawaiState,
  string
> = {
  NOT_SENT: 'Belum Dinilai',
  READY_TO_SEND: 'Belum Dikirim',
  SENT_TO_BKN: 'Sedang dikirim',
  SENT_TO_BKN_SUCCESS: 'Berhasil Dikirim',
  SENT_TO_BKN_FAILED: 'Gagal Dikirim',
}

export const PERIODIK_STATE_BADGE_VARIANTS: Record<
  PeriodikState,
  BadgeProps['variant']
> = {
  COMPLETED: 'success',
  IN_PROGRESS: 'warning',
  NOT_STARTED: 'neutral',
}

export const PERIODIK_PEGAWAI_STATE_BADGE_VARIANTS: Record<
  PeriodikPegawaiState,
  BadgeProps['variant']
> = {
  NOT_SENT: 'critical',
  READY_TO_SEND: 'warning',
  SENT_TO_BKN: 'warning',
  SENT_TO_BKN_SUCCESS: 'success',
  SENT_TO_BKN_FAILED: 'critical',
}

export const PERIODIK_PEGAWAI_DISABLED_STATES: Array<PeriodikPegawaiState> = [
  'SENT_TO_BKN',
  'SENT_TO_BKN_SUCCESS',
]

export const PERIODIK_PERFORMANCE_PRACTICE_RESULTS: Record<
  PeriodikPerformancePracticeResult,
  string
> = {
  BELOW_EXPECTATION: 'Di Bawah Ekspektasi',
  MEET_EXPECTATION: 'Sesuai Ekspektasi',
  EXCEED_EXPECTATION: 'Di Atas Ekspektasi',
}

export const PERIODIK_WORK_BEHAVIOR_RESULTS: Record<
  PeriodikPerformancePracticeResult,
  string
> = {
  BELOW_EXPECTATION: 'Di Bawah Ekspektasi',
  MEET_EXPECTATION: 'Sesuai Ekspektasi',
  EXCEED_EXPECTATION: 'Di Atas Ekspektasi',
}

export const PERIODIK_PERFORMANCE_PREDICATE_RESULTS: Record<
  PeriodikPerformancePredicateResult,
  string
> = {
  VERY_GOOD: 'Sangat Baik',
  GOOD: 'Baik',
  NEED_IMPROVEMENT: 'Butuh Perbaikan',
  BAD: 'Kurang',
  VERY_BAD: 'Sangat Kurang',
}

export const PERIODIK_PERFORMANCE_PREDICATE_RATING_MAPPING: Record<
  string,
  PeriodikPerformancePredicateResult
> = {
  // Format: [Rating Praiktik Kinerja]-[Rating Perilaku Kerja]: [Predikat Kinerja]
  'BELOW_EXPECTATION-BELOW_EXPECTATION': 'VERY_BAD',
  'BELOW_EXPECTATION-MEET_EXPECTATION': 'NEED_IMPROVEMENT',
  'BELOW_EXPECTATION-EXCEED_EXPECTATION': 'NEED_IMPROVEMENT',
  'MEET_EXPECTATION-BELOW_EXPECTATION': 'BAD',
  'MEET_EXPECTATION-MEET_EXPECTATION': 'GOOD',
  'MEET_EXPECTATION-EXCEED_EXPECTATION': 'GOOD',
  'EXCEED_EXPECTATION-BELOW_EXPECTATION': 'BAD',
  'EXCEED_EXPECTATION-MEET_EXPECTATION': 'GOOD',
  'EXCEED_EXPECTATION-EXCEED_EXPECTATION': 'VERY_GOOD',
}

export const PERIODIK_REALIZATION_LABELS: Record<PeriodikRealization, string> =
  {
    REALIZATION_EARLY: 'Progres awal: Pelaksanaan belum tampak menyeluruh',
    REALIZATION_INTERMEDIATE:
      'Progres menengah: Pelaksanaan dilakukan secara konsisten',
    REALIZATION_ADVANCED:
      'Progres lanjut: Pelaksanaan signifikan dan berdampak',
  }

export const FEEDBACK_MAX_LENGTH = 250
